import { NgModule } from '@angular/core';
import { AutofocusByContentDirective } from './directives/autofocus-by-content.directive';
import { AutofocusDirective } from './directives/autofocus.directive';
import { CardTooltipDirective } from './directives/card-tooltip.directive';
import { ConditionalFocusDirective } from './directives/conditional-focus.directive';
import { ConversionHelperDirective } from './directives/conversion-helper.directive';
import { DisableControlDirective } from './directives/disable-control.directive';
import { NoDecimalDirective } from './directives/no-decimal.directive';
import { NoMinusDirective } from './directives/no-minus.directive';
import { NumericNegativeAllowedDirective } from './directives/numeric-negative-allowed.directive';
import { NumericDirective } from './directives/numeric.directive';
import { OptionsScrollDirective } from './directives/options-scoll.directive';
import { OverrideEnterDirective } from './directives/override-enter.directive';
import { PrecisionDirective } from './directives/precision.directive';
import { InputTrimDirective } from './directives/trim.directive';

const directives = [
  AutofocusDirective,
  AutofocusByContentDirective,
  OverrideEnterDirective,
  NoMinusDirective,
  NoDecimalDirective,
  NumericDirective,
  NumericNegativeAllowedDirective,
  InputTrimDirective,
  PrecisionDirective,
  DisableControlDirective,
  CardTooltipDirective,
  ConversionHelperDirective,
  ConditionalFocusDirective,
  OptionsScrollDirective
];

@NgModule({
  declarations: directives,
  exports: directives
})
export class DirectivesModule { }
